import moment from "moment";

import { useConfirm } from "material-ui-confirm";
import { firestore } from "../firebase";
import { useUserProvider } from "../context/UserProvider";
import { Link, useHistory } from "react-router-dom";

import { SeverityPill } from "./SeverityPill";
import Chip from "@mui/material/Chip";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

import { toast } from "react-toastify"; // then this

import {
  IconButton,
  TableCell,
  TableRow,
  Box,
  Typography,
  Card,
  Table,
  useMediaQuery,
  TableBody,
} from "@mui/material";

const Site = ({
  clientCompany,
  clientEmail,
  clientFirstName,
  clientLastName,
  clientTelephone,
  entrepreneurCompany,
  entrepreneurCompanyNumber,
  entrepreneurEmail,
  entrepreneurFirstName,
  entrepreneurLastName,
  entrepreneurTelephone,
  siteConstructionYear,
  siteHousingType,
  siteMunicipality,
  siteNotes,
  siteNumber,
  sitePostalCode,
  siteStreet,

  role,
  user,
  createdAt,
  id,
}) => {
  const confirm = useConfirm();

  const siteRef = firestore.doc(`sites/${id}`);

  const existingField = [
    clientCompany &&
      clientEmail &&
      clientFirstName &&
      clientLastName &&
      clientTelephone &&
      entrepreneurCompany &&
      entrepreneurCompanyNumber &&
      entrepreneurEmail &&
      entrepreneurFirstName &&
      entrepreneurLastName &&
      entrepreneurTelephone &&
      siteConstructionYear &&
      siteHousingType &&
      siteMunicipality &&
      siteNotes &&
      siteNumber &&
      sitePostalCode &&
      siteStreet,
  ];

  const remove = () =>
    siteRef.delete().then(() =>
      //  Alert.info("Post Deleted", 3000)
      toast.info("Site deleted", {
        theme: "colored",
      })
    );

  const { user: currentUser } = useUserProvider();
  const location = useHistory().location.pathname;

  const belongsToCurrentUser = (currentUser, siteAuthor) => {
    if (!currentUser) return false;

    return currentUser.uid === siteAuthor.uid;
  };

  const handleDelete = () => {
    confirm({
      title: "Are you sure?",
      description: "This will permanently delete this site.",
    }).then(() => remove());
  };

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only("xs"));
  // date and time
  const { nanoseconds, seconds } = createdAt !== null && createdAt;
  var timestamp = { nanoseconds, seconds };
  const dateTime = new Date(timestamp?.seconds * 1000);

  return (
    <Card
      elevation={0}
      sx={{
        marginBottom: {
          xs: "14px",
          sm: "22px",
          md: "22px",
          lg: "22px",
        },
      }}
    >
      <Table>
        <TableBody>
          <TableRow
            style={{
              width: "100%",
              borderBottom: "none",
            }}
          >
            <TableCell
              sx={{
                borderBottom: "none",
                width: {
                  xs: "5%",
                  sm: "10%",
                  md: "10%",
                  lg: "10%",
                },
                pl: {
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 2,
                },
              }}
              size="small"
              align="left"
            >
              <Box
                sx={{
                  p: 1,
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark" && isSmallScreen
                      ? "#001E3C"
                      : theme.palette.mode === "light" && isSmallScreen
                      ? "#d5deea"
                      : "#3399ff",
                  borderRadius: 2,
                  maxWidth: "fit-content",
                }}
              >
                <Typography
                  align="center"
                  color={(theme) =>
                    theme.palette.mode === "dark" && isSmallScreen
                      ? "#8eadcc"
                      : "#fff"
                  }
                  variant="subtitle2"
                >
                  {moment(dateTime).format("MMM").toUpperCase()}
                </Typography>
                <Typography
                  align="center"
                  color={(theme) =>
                    theme.palette.mode === "dark" && isSmallScreen
                      ? "#8eadcc"
                      : "#fff"
                  }
                  variant="h6"
                >
                  {moment(dateTime).format("DD").toUpperCase()}
                </Typography>
              </Box>
            </TableCell>
            <TableCell
              sx={{
                borderBottom: "none",
                width: {
                  xs: "80%",
                  sm: "40%",
                  md: "40%",
                  lg: "40%",
                },
                pl: {
                  xs: 0,
                  sm: 2,
                  md: 2,
                  lg: 2,
                },
                pr: {
                  xs: 0,
                  sm: 2,
                  md: 2,
                  lg: 2,
                },
              }}
              size="medium"
              colSpan={6}
              align="left"
            >
              {user && belongsToCurrentUser(currentUser, user) ? (
                <>
                  <Typography variant="body2">
                    <Link to={`/sites/${id}`}>
                      {siteStreet}, {siteNumber}
                    </Link>
                  </Typography>
                  <Typography
                    // color="textSecondary"
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === "dark"
                          ? "rgb(128, 191, 255)"
                          : "#1b78d5",
                      fontWeight: (theme) =>
                        theme.palette.mode === "dark" ? "normal" : "600",
                    }}
                    variant="body2"
                  >
                    {siteHousingType}
                  </Typography>
                </>
              ) : role === "admin" || role === "editor" ? (
                <>
                  <Typography variant="body2">
                    <Link to={`/sites/${id}`}>
                      {siteStreet}, {siteNumber}
                    </Link>
                  </Typography>
                  <Typography
                    // color="textSecondary"
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === "dark"
                          ? "rgb(128, 191, 255)"
                          : "#1b78d5",
                      fontWeight: (theme) =>
                        theme.palette.mode === "dark" ? "normal" : "600",
                    }}
                    variant="body2"
                  >
                    {siteHousingType}
                  </Typography>
                </>
              ) : (
                <>
                  <Typography variant="body2">
                    You must be editor or admin
                  </Typography>
                  <Typography
                    // color="textSecondary"
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === "dark"
                          ? "rgb(128, 191, 255)"
                          : "#1b78d5",
                      fontWeight: (theme) =>
                        theme.palette.mode === "dark" ? "normal" : "600",
                    }}
                    variant="body2"
                  >
                    to see the site address
                  </Typography>
                </>
              )}
            </TableCell>
            <TableCell
              sx={{
                borderBottom: "none",
                p: 0,
                pl: {
                  xs: "8px",
                  sm: 2,
                  md: 2,
                  lg: 2,
                },
                pr: {
                  xs: "0",
                  sm: 2,
                  md: 2,
                  lg: 2,
                },
              }}
              size="small"
              // align="center"
            >
              {existingField != undefined && existingField != "" ? (
                <CheckCircleIcon
                  fontSize={isSmallScreen ? "small" : "medium"}
                  sx={{
                    color: "#00BFC6",
                    justifyContent: "center",
                    mt: 1,
                  }}
                />
              ) : (
                <TimelapseIcon
                  fontSize={isSmallScreen ? "small" : "medium"}
                  sx={{ justifyContent: "center", color: "#8D9EB7", mt: 1 }}
                />
              )}
            </TableCell>

            <TableCell
              sx={{
                borderBottom: "none",
                width: {
                  xs: "4em",
                  sm: "6em",
                  md: "6em",
                  lg: "6em",
                },
                minWidth: {
                  xs: "auto",
                  sm: "6em",
                  md: "6em",
                  lg: "6em",
                },
                pr: {
                  xs: 0,
                  sm: 2,
                  md: 2,
                  lg: 2,
                },
              }}
              align="center"
            >
              {user &&
              belongsToCurrentUser(currentUser, user) &&
              location !== `/site/${id}` ? (
                <IconButton aria-label="delete" onClick={() => handleDelete()}>
                  <DeleteIcon
                    fontSize={isSmallScreen ? "small" : "medium"}
                    style={{ justifyContent: "center", color: "#6593B5" }}
                  />
                </IconButton>
              ) : role === "admin" ? (
                <IconButton aria-label="delete" onClick={() => handleDelete()}>
                  <DeleteIcon
                    fontSize={isSmallScreen ? "small" : "medium"}
                    style={{ justifyContent: "center", color: "#6593B5" }}
                  />
                </IconButton>
              ) : (
                ""
              )}
            </TableCell>
            <TableCell
              sx={{
                borderBottom: "none",
                pl: {
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 2,
                },
                pr: {
                  xs: "7px",
                  sm: 2,
                  md: 2,
                  lg: 2,
                },
              }}
              align="right"
            >
              {user && belongsToCurrentUser(currentUser, user) ? (
                <Link to={`/sites/${id}`}>
                  <IconButton aria-label="edit">
                    <NavigateNextIcon
                      sx={{
                        justifyContent: "center",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "#ffffff" : "#6593B5",
                      }}
                    />
                  </IconButton>
                </Link>
              ) : role === "admin" || role === "editor" ? (
                <Link to={`/sites/${id}`}>
                  <IconButton aria-label="edit">
                    <NavigateNextIcon
                      sx={{
                        justifyContent: "center",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "#ffffff" : "#6593B5",
                      }}
                    />
                  </IconButton>
                </Link>
              ) : (
                <IconButton aria-label="edit">
                  <RemoveCircleOutlineIcon
                    sx={{
                      justifyContent: "center",
                      color: (theme) =>
                        theme.palette.mode === "dark" ? "#8D9EB7" : "#8D9EB7",
                    }}
                  />
                </IconButton>
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
};

export default Site;
